var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecyrely(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8139,
    cy: 10.8139,
    r: 10.8139,
    fill: "url(#paint0_linear_3856_13451)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3856_13451)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3581 4.91801C10.6048 4.82573 10.8742 4.8137 11.1281 4.88363L11.2356 4.91801L15.6106 6.55863C15.8325 6.64181 16.0261 6.78632 16.1689 6.97532C16.3118 7.16432 16.398 7.39002 16.4175 7.62613L16.4219 7.72926V11.0811C16.4219 12.0939 16.1484 13.0879 15.6304 13.9581C15.1124 14.8284 14.369 15.5426 13.4788 16.0255L13.3125 16.1124L11.2162 17.1605C11.1008 17.2181 10.9748 17.2513 10.8459 17.258C10.7171 17.2647 10.5883 17.2447 10.4675 17.1993L10.3775 17.1605L8.28125 16.1124C7.37538 15.6594 6.60861 14.9703 6.06188 14.1178C5.51515 13.2652 5.20874 12.2809 5.175 11.2686L5.17188 11.0811V7.72926C5.17188 7.49246 5.23914 7.26054 5.36583 7.06049C5.49253 6.86044 5.67343 6.70049 5.8875 6.59926L5.98312 6.55863L10.3581 4.91801ZM12.9425 8.93926L10.0687 11.813L8.96375 10.708C8.84647 10.5908 8.68745 10.525 8.52165 10.5251C8.35586 10.5251 8.19688 10.591 8.07969 10.7083C7.9625 10.8256 7.89669 10.9846 7.89675 11.1504C7.89681 11.3162 7.96272 11.4752 8.08 11.5924L9.5825 13.0949C9.64634 13.1588 9.72215 13.2094 9.80558 13.244C9.88901 13.2786 9.97844 13.2964 10.0687 13.2964C10.1591 13.2964 10.2485 13.2786 10.3319 13.244C10.4154 13.2094 10.4912 13.1588 10.555 13.0949L13.8263 9.82301C13.8859 9.76535 13.9336 9.69639 13.9663 9.62014C13.9991 9.54388 14.0163 9.46187 14.017 9.37888C14.0178 9.2959 14.0019 9.2136 13.9705 9.13679C13.9391 9.05998 13.8927 8.99019 13.834 8.93151C13.7753 8.87283 13.7055 8.82642 13.6287 8.79499C13.5519 8.76357 13.4696 8.74775 13.3866 8.74848C13.3036 8.7492 13.2216 8.76644 13.1454 8.79919C13.0691 8.83195 13.0002 8.87956 12.9425 8.93926Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3856_13451",
    x1: 12.2886,
    y1: 24.6318,
    x2: -9.84834,
    y2: 13.3221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8ED84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4954,
    stopColor: "#F5E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84FAD5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3856_13451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(3.29688 3.54614)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecyrely);
export default __webpack_public_path__ + "static/media/secyrely.3cf3b5ce3232f036fd079193faad98d4.svg";
export { ForwardRef as ReactComponent };